// import React, { useEffect } from 'react'
// import { Link } from 'react-router-dom'
// import VerticalNav from '../../components/partials/dashboard/SidebarStyle/verticalnav'
// import DocVerticaltype from './DocVerticaltype';
// import { useSelector } from 'react-redux';
// // import * as SettingSelector from "../../../../store/setting/selectors";
// import * as SettingSelector from "../../store/setting/selectors";
// import Scrollbar from "smooth-scrollbar";

// const Docsidebar = () => {
//   const sidebarType = useSelector(SettingSelector.sidebar_type); // array
//   const sidebarMenuStyle = useSelector(SettingSelector.sidebar_menu_style);
//   const appName = useSelector(SettingSelector.app_name);
//   const minisidebar = () => {
//     document.getElementsByTagName("ASIDE")[0].classList.toggle("sidebar-mini");
//   };
//   useEffect(() => {
//     Scrollbar.init(document.querySelector(".data-scrollbar"));

//     window.addEventListener("resize", () => {
//       const tabs = document.querySelectorAll(".nav");
//       const sidebarResponsive = document.querySelector(
//         '[data-sidebar="responsive"]'
//       );
//       // if (window.innerWidth < 1025) {
//       //   Array.from(tabs, (elem) => {
//       //     if (
//       //       !elem.classList.contains("flex-column") &&
//       //       elem.classList.contains("nav-tabs") &&
//       //       elem.classList.contains("nav-pills")
//       //     ) {
//       //       elem.classList.add("flex-column", "on-resize");
//       //     }
//       //     return elem.classList.add("flex-column", "on-resize");
//       //   });
//       //   if (sidebarResponsive !== null) {
//       //     if (!sidebarResponsive.classList.contains("sidebar-mini")) {
//       //       sidebarResponsive.classList.add("sidebar-mini", "on-resize");
//       //     }
//       //   }
//       // } else {
//       //   Array.from(tabs, (elem) => {
//       //     if (elem.classList.contains("on-resize")) {
//       //       elem.classList.remove("flex-column", "on-resize");
//       //     }
//       //     return elem.classList.remove("flex-column", "on-resize");
//       //   });
//       //   if (sidebarResponsive !== null) {
//       //     if (
//       //       sidebarResponsive.classList.contains("sidebar-mini") &&
//       //       sidebarResponsive.classList.contains("on-resize")
//       //     ) {
//       //       sidebarResponsive.classList.remove("sidebar-mini", "on-resize");
//       //     }
//       //   }
//       // }
//       if (window.innerWidth < 1025) {

//         if (sidebarResponsive !== null) {
//           if (!sidebarResponsive.classList.contains("sidebar-mini")) {
//             sidebarResponsive.classList.add("sidebar-mini", "on-resize");
//           }
//         }
//       } else {
//         if (sidebarResponsive !== null) {
//           if (
//             sidebarResponsive.classList.contains("sidebar-mini") &&
//             sidebarResponsive.classList.contains("on-resize")
//           ) {
//             sidebarResponsive.classList.remove("sidebar-mini", "on-resize");
//           }
//         }
//       }
//     });
//   });
//   const minisidebar2 = () => {
//     const sidebarMini = document.getElementsByTagName("ASIDE")[0];
//     if (sidebarMini.classList.contains('sidebar-mini')) {
//       sidebarMini.classList.remove('sidebar-mini')
//     }
//     else {
//       sidebarMini.classList.add('sidebar-mini')
//     }
//   };
//   return (
//     <>
// <div className="icon material-symbols-outlined iq-burger-menu moblieicon-doc"  onClick={minisidebar2}>
//         {" "}
//         menu{" "}
//       </div>
//       <aside
//         className={`navs-rounded-all sidebar sidebar-default sidebar-base navs-rounded-all mt-[50px]`}
//         id="first-tour"
//         data-toggle="main-sidebar"
//         data-sidebar="responsive"
//       >
//         <div className="sidebar-header border-bottom-0 d-flex align-items-center justify-content-start position-relative">

//           <div
//             className="sidebar-toggle"
//             data-toggle="sidebar"
//             data-active="true"
//             onClick={minisidebar}
//           >
//             <span className="menu-btn d-inline-block is-active">
//               <i className="right-icon material-symbols-outlined icon-rtl">
//                 chevron_left
//               </i>
//             </span>
//           </div>
//         </div>
//         <div className="sidebar-body pt-0 data-scrollbar">
//           <div className="sidebar-list">
// <DocVerticaltype/>
//           </div>
//         </div>
//         <div className="sidebar-footer"></div>
//       </aside> 
//     </>
//   )
// }

// export default Docsidebar




import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Search, Book, Play, Settings, Shield, MessageSquare, HelpCircle, Menu, X, ChevronRight, SlidersHorizontal } from 'lucide-react';

const DocSidebar = ({ sidebarOpen, setSidebarOpen, activeSection, setActiveSection }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  const navigationItems = [
    { 
      id: 'Introduction', 
      label: 'Introduction', 
      icon: Book, 
      status: 'Updated',
      route: '/pages/documention/Introduction',
      tooltip: 'Introduction'
    },
    { 
      id: 'quick-start', 
      label: 'Getting Started', 
      icon: Play, 
      status: 'New',
      route: '/pages/documention/quick-start',
      tooltip: 'Getting Started'
    },
    { 
      id: 'managing-dashboard', 
      label: 'Managing Dashboard', 
      icon: Settings,
      route: '/pages/documention/managing-dashboard',
      tooltip: 'Managing Dashboard'
    },
    { 
      id: 'additional-feature', 
      label: 'Advanced Features', 
      icon: SlidersHorizontal,
      route: '/pages/documention/additional-feature',
      tooltip: 'Advanced Features'
    },
    { 
      id: 'security', 
      label: 'Security', 
      icon: Shield, 
      status: 'Updated',
      route: '/pages/documention/security',
      tooltip: 'Security'
    },
    { 
      id: 'quick-reply', 
      label: 'Quick Reply', 
      icon: MessageSquare,
      route: '/pages/documention/quick-reply',
      tooltip: 'Quick Reply'
    },
    { 
      id: 'support-troubleshooting', 
      label: 'Support & Troubleshooting', 
      icon: HelpCircle,
      route: '/pages/documention/support-troubleshooting',
      tooltip: 'Support & Troubleshooting'
    }
  ];

  const filteredItems = navigationItems.filter(item =>
    item.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleNavClick = (item) => {
    setActiveSection(item.id);
    setSidebarOpen(false); // Close sidebar on mobile after selection
  };

  return (
    <>
      {/* Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-40 w-80 bg-white border-r border-gray-200 transform transition-transform duration-300 ease-in-out ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} 2xl:translate-x-0 pt-[104px]  docsidebar`}>
        <div className="flex flex-col h-full w-80">
          {/* Search */}
          <div className="p-4 border-b border-gray-200">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
              <input
                type="text"
                placeholder="Search documentation..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#50B5FF] focus:border-transparent outline-none"
              />
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 overflow-y-auto p-4">
            <ul className="space-y-2">
              {filteredItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.route;
                return (
                  <li key={item.id} className="nav-item my-2">
                    <NavLink
                      to={item.route}
                      onClick={() => handleNavClick(item)}
                      className={`w-full flex items-center justify-between px-4 py-3 rounded-lg text-left transition-all duration-200 nav-link unlist ${
                        isActive
                          ? 'bg-[#50B5FF] text-white shadow-lg active'
                          : 'text-gray-700 hover:bg-gray-100'
                      }`}
                      aria-current={isActive ? 'page' : undefined}
                    >
                      <div className="flex items-center">
                        <OverlayTrigger
                          placement="right"
                          overlay={<Tooltip>{item.tooltip}</Tooltip>}
                        >
                          <Icon size={18} className="mr-3 flex-shrink-0 icon material-symbols-outlined" />
                        </OverlayTrigger>
                        <span className="font-medium item-name">{item.label}</span>
                      </div>
                      {item.status && (
                        <span className={`px-2 py-1 text-xs rounded-full font-medium ${
                          item.status === 'New' 
                            ? 'bg-green-100 text-green-700' 
                            : 'bg-blue-100 text-blue-700'
                        }`}>
                          {item.status}
                        </span>
                      )}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </nav>

          {/* Footer */}
          <div className="p-4 border-t border-gray-200">
            <p className="text-xs text-gray-500">Version 2.1.0</p>
            <p className="text-xs text-gray-500">Last updated: Dec 2024</p>
          </div>
        </div>
      </div>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </>
  );
};

export default DocSidebar;